import React from 'react';
import { IChartLine } from '../hooks/useChartLines';

interface IProps {
  name: string;
  fill: string;
  x: number;
  y: number;
  width: number;
  height: number;
  opacity: number;
  stroke: IChartLine['type'];
}

const StyledBar = (props: any) => {
  const { name, fill, x, opacity, stroke } = props as IProps;
  const height = !isNaN(props?.height) ? props.height : 0;
  // Calculate the correct y position based on whether height is positive or negative
  const y = height >= 0 ? props.y : props.y + height;
  const absHeight = Math.abs(height);

  // Apply a diagonal hatch pattern to comparison bars
  if (stroke === 'pattern') {
    const patternId = `diagonalHatch-${name}`;

    return (
      <svg opacity={opacity}>
        <pattern
          id={patternId}
          patternUnits="userSpaceOnUse"
          width="4"
          height="4"
        >
          <path
            d="M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2"
            stroke={fill}
            strokeWidth={1}
          />
        </pattern>
        <rect
          x={x}
          y={y}
          width={props.width}
          height={absHeight}
          stroke={fill}
          fill={`url(#${patternId})`}
        />
      </svg>
    );
  }

  if (stroke === 'dashed') {
    return (
      <rect
        x={x}
        y={y}
        width={props.width}
        height={absHeight}
        fill="transparent"
        stroke={fill}
        opacity={opacity}
      />
    );
  }

  return (
    <rect
      x={x}
      y={y}
      width={props.width}
      height={absHeight}
      fill={fill}
      opacity={opacity}
    />
  );
};

export default StyledBar;
